export const GET_BUSINESS_TYPES = 'GET_BUSINESS_TYPES';
export const UNATORIZED = 'UNATORIZED';
export const ERROR_BUSINESS_TYPES = 'ERROR_BUSINESS_TYPES';
